import { Text } from '@simplywallst/ui-core';
import {
  Container,
  Logo,
  Content,
  SectionLogo,
  SectionText,
  HeadingText,
} from './styled';
import { Nbsp } from '@/components/nbsp';

export const SplashPanelRegister = () => {
  return (
    <Container>
      <Content>
        <SectionLogo>
          <Logo />
        </SectionLogo>
        <SectionText>
          <HeadingText as={'h1'}>
            The revolution for
            <br />
            <Text as={'span'} color={'brand01'}>
              long-term
              <Nbsp />
              investors
            </Text>
          </HeadingText>

          <Text color={'darkerGray'}>
            Simply Wall St is built on the principles of long term investing,
            helping individuals with every aspect of building a successful stock
            portfolio
          </Text>
        </SectionText>
      </Content>
    </Container>
  );
};
